export const API_URL = process.env.REACT_APP_API_ENDPOINT;

// Service-specific URLs for local testing against deployed namespaces
// Falls back to API_URL with service path prefix if not set
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_ENDPOINT || `${API_URL}/admin`;
export const CHANNELS_API_URL =
  process.env.REACT_APP_CHANNELS_API_ENDPOINT || `${API_URL}/channels`;
export const MARKETPLACE_API_URL =
  process.env.REACT_APP_MARKETPLACE_API_ENDPOINT || `${API_URL}/marketplace`;

export const routerFutureFlags = { v7_startTransition: true, v7_relativeSplatPath: true };
